var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 391,
    height: 374,
    viewBox: "0 0 391 374",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.699707 325.208H74.7849V308.19H17.9289V133.393H0.699707V325.208Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M315.993 60.1923V77.211H372.849V252.007H390.078V60.1923H315.993Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.388 289.164C141.558 289.164 97.7546 245.887 97.7546 192.695C97.7546 139.513 141.558 96.2265 195.388 96.2265C249.225 96.2265 293.022 139.513 293.022 192.695C293.022 245.887 249.225 289.164 195.388 289.164ZM195.388 76.9328C130.796 76.9328 78.2278 128.873 78.2278 192.695C78.2278 256.518 130.796 308.458 195.388 308.458C259.98 308.458 312.548 256.518 312.548 192.695C312.548 128.873 259.98 76.9328 195.388 76.9328Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M304.208 17.3525H276.229C269.644 17.3525 264.306 24.2772 264.306 32.8114C264.306 41.3555 269.644 48.2703 276.229 48.2703H304.208C310.793 48.2703 316.131 41.3555 316.131 32.8114C316.131 24.2772 310.793 17.3525 304.208 17.3525Z",
    fill: "#DF772C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.699707 133.394H17.9289V77.2111H74.7849V60.1925H0.699707V133.394Z",
    fill: "#D1D2D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M372.849 307.912V308.19H315.993V325.208H390.078V252.007H372.849V307.912Z",
    fill: "#D1D2D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhite);
export default __webpack_public_path__ + "static/media/icon_white.30c3a05c86b4c9a196dec18e86a722e5.svg";
export { ForwardRef as ReactComponent };